// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--scale: calc(100vw / 1920);--padInline: calc(var(--scale) * 40)}@media only screen and (max-width: 1200px){:root{--scale: calc(100vw / 768);--padInline: calc(var(--scale) * 16)}}@media only screen and (max-width: 767px){:root{--scale: calc(100vw / 390);--padInline: calc(var(--scale) * 12)}}html{font-size:calc(var(--scale)*16)}html,body{scrollbar-gutter:stable}@media only screen and (max-width: 1200px){html{font-size:calc(var(--scale)*10)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
